var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"line-chart-title"},[_vm._v(_vm._s(_vm.chartConfig.info))]),_c('div',{staticClass:"line-chart",attrs:{"id":_vm.title}})])
}
var staticRenderFns = []

export { render, staticRenderFns }